import { Box, Button, Stack } from '@chakra-ui/react';
import React from 'react';
import CoveyLogo from '../assets/Icons/logo';
import RightArrow from '../assets/Icons/rightArrow';
import LogoSm from '../assets/Icons/logoSm';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();

  return (
    <Box
      h={['66px', '66px', '66px', '77px']}
      borderBottom="1px solid rgba(0, 0, 0, 0.10)"
      background="#FFF"
      padding={['14px 12px', '14px 12px', '14px 12px', '20px 24px']}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Box
        display={['none', 'none', 'block', 'block']}
        cursor="pointer"
        onClick={() => {
          navigate('/');
        }}
      >
        <CoveyLogo />
      </Box>

      <Box
        display={['block', 'block', 'none', 'none']}
        onClick={() => {
          navigate('/');
        }}
      >
        <LogoSm />
      </Box>

      <Stack direction="row" spacing={4}>
        <Button
          color="#000"
          fontSize=" 14px"
          fontStyle="normal"
          fontWeight=" 500"
          lineHeight="normal"
          background="rgba(0, 0, 0, 0.10)"
          borderRadius="12px"
          h={'37px'}
        >
          Login
        </Button>
        <Button
          rightIcon={<RightArrow />}
          color="white"
          borderRadius="12px"
          background="#5772FF"
          fontSize=" 14px"
          fontStyle="normal"
          fontWeight=" 500"
          lineHeight="normal"
          h={'37px'}
        >
          Sign up
        </Button>
      </Stack>
    </Box>
  );
}
